<nav *ngIf="errors?.length > 0" aria-labelledby="error-summary">
  <div class="alert alert-error mt-0 mb-8" role="alert" data-module="error-summary">
    <div aria-label="Fejl"></div>
    <div class="alert-body">
      <h2 class="alert-heading" id="error-summary">Der er problemer</h2>
      <ul class="alert-text nobullet-list">
        <li *ngFor="let error of errors">
          <a
            [routerLink]="['.']"
            [fragment]="error.controlName"
            [queryParams]="{ i: counter }"
            queryParamsHandling="merge"
            class="function-link"
            (click)="incrementCounter()"
            >{{ error.errorMessage }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</nav>
